module.exports = __webpack_public_path__ + "static/media/0022.a5b5fe95.jpg";